<template>
    <div class="global-nav font-weight-medium text-none">
        {{ $t("sidebar.filters." + filterType) }}
    </div>
</template>

<script>
    export default {
        name: "TitleFilter",
        props: {
            filterType: {
                type: String,
                required: true,
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/sidebar/cutaway/components/TitleFilter.vue